import { cloneElement } from 'react'

export const ConditionalBoolean = ({
  record, children, condition = () => false, key, ...rest
}) => cloneElement(children, {
  record: { condition: condition(record), ...record },
  ...rest
})
